var exports = {
  "z": "x4c3adb35--b53ee5--summary",
  "RR": "x4c3adb35--b53ee5--listing",
  "RC": "x4c3adb35--b53ee5--preloader",
  "CP": "x4c3adb35--b53ee5--advertising-labeling",
};

module.exports = exports;
